import * as React from 'react';
import { Groups } from '../../Enum/Groups';
import { GroupNavItem } from './GroupNavItem';
import { SolutionNavigationProps } from './SolutionNavigationProps';

export class BeltScalesNav extends React.PureComponent<SolutionNavigationProps> {
    public render() {
        return <nav className="pf-solution-sub-nav">
            <ul>
                <GroupNavItem group={Groups.MeasuringRoller}
                              isActive={this.props.currentGroup === Groups.MeasuringRoller}/>
                <GroupNavItem group={Groups.Electronics}
                              isActive={this.props.currentGroup === Groups.Electronics}/>
            </ul>
        </nav>;
    }
}
